module.exports = __webpack_public_path__ + "static/media/Lexington-Condo-Homes-6th_amendment.3e0b97da.pdf";